import moment from 'moment';
import VueMoment from 'vue-moment';
import VueI18n from 'vue-i18n';

import appConfig from '../config/app.config.json';
import locales from './locales';
import Vuetify from './plugins/ui';
import Store from './store';
import Router from './router';
import routes from './router/routes';
import settings from './utils/settings';
import publicUtils from './utils/public';
import console from './utils/console';
import auth from './utils/auth';
import apiOperation from './utils/api-operation';
import apiClient from './utils/api-client';


export const detectLanguage = () => {
  const pattern = /[A-z]{2}-[A-z]{2}/;
  let lang = navigator.language;
  if (lang && pattern.test(lang)) {
    lang = lang.substr(0, lang.indexOf('-')).toLowerCase();
  }
  return lang;
};


export const options_default = {
  apiClient: {},
  apiOperation: {},
  appConfig,
  language: detectLanguage(),
  locales,
  router: {userStartPage: '/home'},
  routes,
  storeModules: {},
  vuetifyConfig: {}
};


/**
 * @param {Object} Vue
 * @param {Object} options
 * @return {Object} Vue Options
 */
const XcaAppCore = (Vue, options) => {
  options = {
    ...options_default,
    ...options
  };


  // ---------------------------------------------------------------------------
  // Language
  // ---------------------------------------------------------------------------
  const defaultLang = options.appConfig.language || 'en';
  const language = options.language || defaultLang;


  // ---------------------------------------------------------------------------
  // Vue Settings
  // ---------------------------------------------------------------------------
  Vue.config.productionTip = false;
  Vue.config.devtools = settings.devtools;


  // ---------------------------------------------------------------------------
  // Vue Plugins
  // ---------------------------------------------------------------------------
  Vue.use(VueMoment, {moment});
  Vue.moment.locale(language);

  Vue.use(VueI18n);

  const i18n = new VueI18n({
    locale: options.language,
    fallbackLocale: defaultLang,
    messages: options.locales
  });

  const vuetify = new Vuetify(Vue, options);
  const store = new Store(Vue, options);
  const router = new Router(Vue, options);


  // ---------------------------------------------------------------------------
  // Vue Settings, Mixins, Utils
  // ---------------------------------------------------------------------------
  Vue.prototype.$appConfig = {
    ...options.appConfig,
    language // Overwrite with actual language.
  };

  Vue.prototype.$utils = publicUtils(Vue, options);

  Vue.prototype.$console = console;

  Vue.prototype.$auth = auth(Vue, options);

  Vue.prototype.$apiOperation = apiOperation(Vue, options);

  apiClient(Vue, options); // Sets `Vue.prototype.$apiClient`.

  // ---------------------------------------------------------------------------
  // Vue Options
  // ---------------------------------------------------------------------------
  return {
    vuetify,
    i18n,
    router,
    store
  };
};

export default XcaAppCore;
